import { Spin } from "antd";
import type { SpinProps } from "antd";
import styles from "./styles.module.scss";

export const AppLoader = (props: SpinProps) => {
  return (
    <div className={styles["loader"]}>
      <Spin {...props} />
    </div>
  );
};
